import { Brand, createBranded } from '@deltasierra/type-utilities';

export type EmailTemplateContentId = Brand<string, 'EmailTemplateContentId'>;
export const EmailTemplateContentId = createBranded<EmailTemplateContentId>();
